<div class="ad-explorer flex-wrapper flex-col" [ngClass]="styleClass">
  <div class="ad-explorer-header flex-wrapper padding">
    <div *ngIf="!templateMap['header']; else headerTemp"></div>
    <ng-template #headerTemp>
      <ng-container *ngTemplateOutlet="templateMap['header']; context:{$implicit:data}"></ng-container>
    </ng-template>
  </div>
  <div class="ad-explorer-main flex-main flex-wrapper no-padding">
    <!-- <div class="ad-explorer-side padding">
      <div class="side-toggler" *ngIf="showToggle">
        <button pButton class="p-button-text" label="Hide"></button>
      </div>
      <p-tree *ngIf="!templateMap['navi']; else naviTemp" [(selection)]="selectedNode" [value]="treeData"
        [contextMenu]="cm" selectionMode="single" styleClass="ad-explorer-tree" [filter]="true"
        [style]="{'width':'100%'}" [virtualScroll]="true" (onNodeSelect)="nodeSelect($event)" [virtualNodeHeight]="20"
        scrollHeight="600px">
        <ng-container *ngFor="let temp of templates">
          <ng-template let-node pTemplate="{{temp.name}}">
            <ng-template *ngTemplateOutlet="temp.template;context:{$implicit:node}"></ng-template>
          </ng-template>
        </ng-container>
      </p-tree>
      <ng-template #naviTemp>
        <ng-container *ngTemplateOutlet="templateMap['navi']; context:{$implicit:naviData}"></ng-container>
      </ng-template>
    </div>
    <div class="flex-main flex-wrapper flex-col padding">
      <div class="ad-explorer-header flex-wrapper center-items">
        <div class="flex-main">
          <p-breadcrumb [model]="path" (onItemClick)="selectNode($event.item)"></p-breadcrumb>
        </div>
        <div class="toolbar-container">
          <ng-template *ngTemplateOutlet="detailComponent?.buttons$ | async">
          </ng-template>
        </div>
      </div>
      <div class="flex-main ad-explorer-detail">
        <ng-template *ngIf="!templateMap['main'];else mainTemp" cdkPortalOutlet></ng-template>
        <ng-template #mainTemp>
          <ng-container *ngTemplateOutlet="templateMap['main']; context:{$implicit:selectedNode}">
          </ng-container>
        </ng-template>
      </div>
    </div> -->
    <mat-drawer-container style="width: 100%;" [hasBackdrop]="hasBackdrop">
      <mat-drawer #drawer [mode]="sideNaviMode" [opened]="sideNaviOpened">
        <div class="flex-wrapper flex-col height-100-pct">
          <div class="side-toggler" *ngIf="showToggle">
            <button pButton class="p-button-text" label="Hide" (onClick)="toggleSideNav()"></button>
          </div>
          <ng-content select="[tree-toolbar]"></ng-content>
          <div class="flex-main flex-wrapper height-100-pct">
            <p-tree *ngIf="!templateMap['navi']; else naviTemp" [(selection)]="selectedNode" [value]="treeData"
              [contextMenu]="cm" [selectionMode]="selectionMode" [propagateSelectionDown]="propagateSelectionDown"
              styleClass="ad-explorer-tree" [filter]="true" [virtualScroll]="true" (onNodeSelect)="nodeSelect($event)"
              [virtualNodeHeight]="20" scrollHeight="100%">
              <ng-container *ngFor="let temp of templates">
                <ng-template let-node pTemplate="{{temp.name}}">
                  <ng-template *ngTemplateOutlet="temp.template;context:{$implicit:node}"></ng-template>
                </ng-template>
              </ng-container>
            </p-tree>
          </div>
        </div>
        <ng-template #naviTemp>
          <ng-container *ngTemplateOutlet="templateMap['navi']; context:{$implicit:naviData}"></ng-container>
        </ng-template>
      </mat-drawer>
      <mat-drawer-content class="flex-wrapper flex-col" style="display: flex;" autosize>
        <div *ngIf="hasHeaderInMain" class="ad-explorer-header flex-wrapper center-items">
          <div class="flex-main flex-wrapper center-items">
            <ng-container *ngTemplateOutlet="pathTemplate"></ng-container>
            <div class="flex-main">
              <p-breadcrumb [model]="path" (onItemClick)="selectNode($event.item)"></p-breadcrumb>
            </div>
          </div>
          <div class="toolbar-container">
            <ng-template *ngTemplateOutlet="detailComponent?.buttons$ | async">
            </ng-template>
          </div>
        </div>
        <div class="flex-main ad-explorer-detail">
          <ng-template *ngIf="!templateMap['main'];else mainTemp" cdkPortalOutlet></ng-template>
          <ng-template #mainTemp>
            <ng-container *ngTemplateOutlet="templateMap['main']; context:{$implicit:selectedNode}">
            </ng-container>
          </ng-template>
        </div>
      </mat-drawer-content>
    </mat-drawer-container>
  </div>
  <div class="ad-explorer-footer padding" *ngIf="templateMap['footer']">
    <!-- <div *ngIf="!templateMap['footer']; else footerTemp"></div> -->
    <ng-template #footerTemp>
      <ng-container *ngTemplateOutlet="templateMap['footer']; context:{$implicit:data}"></ng-container>
    </ng-template>
  </div>
</div>
<ng-content></ng-content>

<p-contextMenu #cm [model]="menuItems"></p-contextMenu>
<p-toast></p-toast>
